import * as React from 'react';

import {Question} from './Question';
import {QuestionEntry, ScanEntry} from '../data/Data';
import {StateContext} from './StateContext';
import {URLScanData} from '../data/URLData';

type ScanProps = {
    // enabled is used to initially check if the scan start in active mode
    enabled: boolean;
    scan: ScanEntry;
};

// tslint:disable-next-line function-name
export function Scan(props: ScanProps): JSX.Element {
    const [active, setActive] = React.useState<boolean>(props.enabled);
    const {state, dispatch} = React.useContext(StateContext);

    React.useEffect((): void => {
        if (props.enabled) {
            setActive(true);
        }
    }, [props.enabled]);

    React.useEffect((): void => {
        const o: URLScanData = state.urlData[state.scans[0].first] || {};
        const aq: string[] = Object.keys(o);
        const nextQuestion: QuestionEntry | null = props.scan.questions[parseInt(aq[aq.length - 1], 10)];

        if (props.scan.questions) {
            dispatch({
                type: 'TOOLTIP',
                payload: {
                    questionId: nextQuestion?.next || state.scans[0].first,
                },
            });
        }
    }, []);

    function toggleActive(): void {
        setActive(!active);
    }

    function renderQuestions(): JSX.Element[] {
        const questions: JSX.Element[] = [];

        if (!active) {
            return questions;
        }

        let next: number | null = props.scan.first;
        let counter: number = 0;
        let previous: QuestionEntry | undefined;

        while (next !== null) {
            const question: QuestionEntry | undefined =
                props.scan.questions[next];

            if (question === undefined) {
                throw new Error(`Unable to find next question "${next}"`);
            }

            const first: boolean = previous === undefined;
            const enabled: boolean =
                previous === undefined ||
                props.scan.questions[previous?.id].answer !== undefined;
            const showTooltip: boolean = state.tooltip === question.id;

            counter += 1;
            next = question.next;
            previous = question;

            questions.push(
                <Question
                    key={question.id}
                    first={first}
                    scanId={props.scan.id}
                    counter={counter}
                    enabled={enabled}
                    question={question}
                    showTooltip={showTooltip}
                />,
            );
        }

        return questions;
    }

    return (
        <article className="c-quickscan" id={String(props.scan.id)}>
            <div
                className={`c-quickscan__item  ${active ? 'active' : ''}  ${
                    props.scan.complete ? 'complete' : ''
                }`}
            >
                <header className="c-quickscan__header">
                    <h2 className="c-quickscan__title">
                        <button
                            type="button"
                            className="c-quickscan__button"
                            onClick={toggleActive}
                        >
                            {props.scan.title}
                        </button>
                    </h2>
                </header>

                <section className="c-quickscan__body">
                    {renderQuestions()}
                </section>
            </div>
        </article>
    );
}
